import { Button, ButtonProps } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface ButtonDeleteProps extends ButtonProps {
	onClick: () => void;
	children?: React.ReactNode;
	props?: any;
}

export function ButtonDelete({
	onClick,
	children = "Delete",
	...props
}: ButtonDeleteProps) {
	return (
		<Button
			variant="ghost-red"
			onClick={onClick}
			leftIcon={<FontAwesomeIcon icon={["far", "trash-can"]} />}
			{...props}
		>
			{children}
		</Button>
	);
}
